import { state_ctrl_factory } from 'ww2_analytics/common/state_ctrl';
import { inject_video_form } from 'ww2_analytics/video/common/forms';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory('video_api', function(service_api, $scope, model) {
        $scope.rows = [];
        service_api.video_count(model).then(rows => $scope.rows = rows);
    }),
};

export default inject_video_form({
    url: '/per_day_in_game',
    reloadOnSearch: false,
    data: {
        priority: 806,
        title: 'Per day in game',
        role: 'video',
    },
    views: {
        '': main_view,
    },
});
